import { render, staticRenderFns } from "./Detourage.vue?vue&type=template&id=4ca7971c&scoped=true"
import script from "./Detourage.vue?vue&type=script&lang=js"
export * from "./Detourage.vue?vue&type=script&lang=js"
import style0 from "./Detourage.vue?vue&type=style&index=0&id=4ca7971c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca7971c",
  null
  
)

export default component.exports